import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'clsx';
import { memo } from 'react';
import { ReactSVG } from 'react-svg';
import * as Icons from './Svg.Icons';
import s from './Svg.module.css';
const SvgFC = ({ name, size = 's24', disabled, width, height, onClick, className }) => {
    const icon = Icons[name];
    const style = width && height ? { width: `${width}px`, height: `${height}px` } : {};
    return onClick ? (_jsx("button", { disabled: disabled, className: cn(s.button, className), onClick: (e) => {
            e.stopPropagation();
            onClick();
        }, children: _jsx(ReactSVG, { src: icon, style: style, className: cn(s[size], className, disabled && s.disabled) }) })) : (_jsx(ReactSVG, { title: "", src: icon, style: style, className: cn(s[size], className) }));
};
export const Svg = memo(SvgFC);
//# sourceMappingURL=Svg.js.map